
 <form [formGroup]="form">
  <mat-form-field class="entity">
    <input
      type="text"
      #entity
      matInput
      placeholder="Entidad"
      formControlName="Entity"
      required
      [matAutocomplete]="autEntity"
    />
    <mat-autocomplete
      #autEntity="matAutocomplete"
      [displayWith]="filterCompleteEntity.displayFn"
    >
      <mat-option
        *ngFor="let entity of filterCompleteEntityOptions | async"
        [value]="entity"
      >
        {{ entity.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="plan">
    <input
      type="text"
      #plan
      matInput
      placeholder="Plan"
      formControlName="Plan"
      required
      [matAutocomplete]="planAutocomplete"
    />
    <mat-autocomplete
      #planAutocomplete="matAutocomplete"
      [displayWith]="filterCompletePlan.displayFn"
    >
      <mat-option
        *ngFor="let plan of filterCompletePlanOptions | async"
        [value]="plan"
      >
        {{ plan.Name }}
      </mat-option></mat-autocomplete
    >
  </mat-form-field>

  <mat-form-field class="aliquotTax">
    <input
      type="text"
      #aliquotTax
      matInput
      placeholder="Alícuota"
      formControlName="AliquotTax"
      required
      [matAutocomplete]="aliquotTaxAutocomplete"
    />
    <mat-autocomplete
      #aliquotTaxAutocomplete="matAutocomplete"
      [displayWith]="filterCompleteAliquotTax.displayFn"
    >
      <mat-option
        *ngFor="let item of filterCompleteAliquotTaxOptions | async"
        [value]="item"
      >
        {{ item.Name }}
      </mat-option></mat-autocomplete
    >
  </mat-form-field>

  <button *ngIf="formIsValid && !readOnly" (click)="revalorizate()" class="center" matTooltip="Revalorizar" type="button" mat-mini-fab>
    <mat-icon>autorenew</mat-icon>
  </button>


  <button *ngIf="normative"  class="margin-left-large" (click)="showNormative()" mat-raised-button>Normas</button>

</form>
